import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchMe } from './api'
import { useAuthStore } from '@/store/auth.store'

/**
 * ÚNICA fonte de verdade pra hidratar o user a partir do cookie httpOnly.
 * Sucesso → setUser(user) → status='authenticated'.
 * Erro/401 → setUser(null) → status='unauthenticated'.
 * Componentes consumidores (ProtectedRoute, LoginPage) só LEEM do store.
 */
export function AuthBootstrap() {
  const setUser = useAuthStore((s) => s.setUser)

  const { data, isError, isSuccess, isFetched } = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: fetchMe,
    retry: false,
    staleTime: 5 * 60_000,
  })

  useEffect(() => {
    if (!isFetched) return
    if (isSuccess && data) setUser(data)
    else if (isError) setUser(null)
  }, [data, isError, isSuccess, isFetched, setUser])

  return null
}
